export const filterNames = ["cities", "companies", "faculty", "category"];